var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 10.882,
    viewBox: "0 0 20 10.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    transform: "translate(-661.387 -602.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M676.468,638.422a1.784,1.784,0,1,0,1.784,1.784A1.786,1.786,0,0,0,676.468,638.422Zm0,2.743a.959.959,0,1,1,.959-.959A.96.96,0,0,1,676.468,641.165Z",
    transform: "translate(-10.555 -28.152)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M733.038,638.422a1.784,1.784,0,1,0,1.784,1.784A1.786,1.786,0,0,0,733.038,638.422Zm0,2.743a.959.959,0,1,1,.959-.959A.96.96,0,0,1,733.038,641.165Z",
    transform: "translate(-55.459 -28.152)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M706.438,620.842h-.147a.442.442,0,0,0-.442.442v.174a.442.442,0,0,0,.442.442h.138a.545.545,0,0,0,.391-.128.476.476,0,0,0,.135-.362.589.589,0,0,0-.139-.411A.491.491,0,0,0,706.438,620.842Z",
    transform: "translate(-35.293 -14.198)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M680.68,608.031a9.191,9.191,0,0,0-3.337-1.28s-3.2-3.706-5.186-3.706c-.792,0-5.123-.089-5.123-.089-2.172,0-5.646,1.829-5.646,5.28v2.955a1.091,1.091,0,0,0,1.091,1.091h1.037c-.007-.075-.012-.151-.012-.229a2.41,2.41,0,1,1,4.82,0c0,.077,0,.153-.012.229h6.869c-.007-.075-.012-.151-.012-.229a2.41,2.41,0,1,1,4.82,0c0,.077,0,.153-.012.229h.434a.966.966,0,0,0,.931-1.091S681.642,608.9,680.68,608.031Zm-8.506.032a1.594,1.594,0,0,1-1.054.321H671a.442.442,0,0,0-.442.442v.36a.442.442,0,1,1-.883,0V606.4a.442.442,0,0,1,.442-.442h1.021a1.7,1.7,0,0,1,.744.155,1.167,1.167,0,0,1,.5.44,1.2,1.2,0,0,1,.177.648A1.061,1.061,0,0,1,672.174,608.063Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPCar);
export default __webpack_public_path__ + "static/media/p-car.b5382f2c.svg";
export { ForwardRef as ReactComponent };